// extracted by mini-css-extract-plugin
module.exports = {"listItem":"listItem_3RK4T","propertyName":"propertyName_1IHeK","showMoreBtn":"showMoreBtn_1Clu3"};